import { render, staticRenderFns } from "./ShadowGroupNameModal.vue?vue&type=template&id=7d0442fa&scoped=true"
import script from "./ShadowGroupNameModal.vue?vue&type=script&lang=js"
export * from "./ShadowGroupNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0442fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0442fa')) {
      api.createRecord('7d0442fa', component.options)
    } else {
      api.reload('7d0442fa', component.options)
    }
    module.hot.accept("./ShadowGroupNameModal.vue?vue&type=template&id=7d0442fa&scoped=true", function () {
      api.rerender('7d0442fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ShadowGroupNameModal.vue"
export default component.exports